import {
  CalendarPrimeReact,
  Checkbox,
  SearchInput,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import HeaderWrapper from "common/components/HeaderWrapper"
import Icon from "common/components/Icon"
import {
  InformesCommonProps,
  ModesInformes,
} from "features/Contabilidad/contants"
import { Dropdown } from "primereact/dropdown"
import { ProgressSpinner } from "primereact/progressspinner"
import { useTranslation } from "react-i18next"

interface OptionsProps {
  value: number | boolean | undefined | null
  label: string
}

const SubMenuHeader = ({
  title,
  handleDownload,
  informesFilters,
  setInformesFilters,
  secondOptions = [],
  secondPlaceholder = "",
  firstOptions = [],
  firstPlaceholder = "",
  isLoadingExcel = false,
  mode,
}: {
  title: string
  handleDownload: () => void
  informesFilters: InformesCommonProps
  setInformesFilters: React.Dispatch<React.SetStateAction<InformesCommonProps>>
  secondOptions: OptionsProps[]
  secondPlaceholder?: string
  firstOptions: OptionsProps[]
  firstPlaceholder?: string
  isLoadingExcel: boolean
  mode: ModesInformes
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const handleCheckboxSoloCuentas = () => {
    setInformesFilters((prevState) => ({
      ...prevState,
      SoloCuentasConSaldo: !prevState.SoloCuentasConSaldo,
    }))
  }

  return (
    <HeaderWrapper
      title={title}
      className='tw-rounded-none'
    >
      <div className='flex align-items-center approval-filter-items'>
        <div className='flex align-items-center dropdown_container'>
          <div className='tw-flex tw-items-center tw-py-1'>
            <Checkbox
              id='sumasSaldos-solo-cuentas-con-saldo'
              className='tw-mr-2'
              isChecked={informesFilters.SoloCuentasConSaldo}
              onClick={() => handleCheckboxSoloCuentas()}
            />
            <span
              className='tw-items-center tw-mb-0 tw-py-1 tw-cursor-pointer tw-text-sm'
              onClick={() => handleCheckboxSoloCuentas()}
            >
              {t("informes.saldos.filter.onlyAccountsWithMovLabel")}
            </span>
          </div>
          <Dropdown
            className='[&_.p-dropdown-label.p-inputtext]:!tw-text-sm'
            panelClassName='[&_.p-dropdown-item]:!tw-text-sm'
            value={informesFilters?.[mode].firstDropdownValue}
            options={firstOptions}
            optionValue='value'
            optionLabel='label'
            onChange={({ value }) => {
              setInformesFilters((prevState) => ({
                ...prevState,
                [mode]: {
                  ...prevState[mode],
                  firstDropdownValue: value,
                },
              }))
            }}
            placeholder={firstPlaceholder}
          />
          <Dropdown
            className='[&_.p-dropdown-label.p-inputtext]:!tw-text-sm'
            panelClassName='[&_.p-dropdown-item]:!tw-text-sm'
            value={informesFilters?.[mode].secondDropdownValue}
            options={secondOptions}
            onChange={({ value }) => {
              setInformesFilters((prevState) => ({
                ...prevState,
                [mode]: {
                  ...prevState[mode],
                  secondDropdownValue: value,
                },
              }))
            }}
            placeholder={secondPlaceholder}
          />
        </div>

        <div className='calendar-container tw-relative tw-mr-3 !tw-mx-0 xl:!tw-mr-2 [&&_.calendar-selected_.p-inputtext]:!tw-h-[40px] [&&_.p-calendar_.p-inputtext]:!tw-h-[40px] [&&_.p-calendar_.p-datepicker-trigger]:!tw-h-[40px]'>
          {informesFilters?.dateFilter && (
            <FontAwesomeIcon
              icon={["fal", "calendar-lines"]}
              className='!tw-absolute tw-text-simple-10 tw-top-2 tw-left-6 tw-h-5 tw-z-10 tw-cursor-pointer tw-pt-0.5'
            />
          )}
          <CalendarPrimeReact
            value={informesFilters?.dateFilter}
            selectionMode='range'
            locale={language}
            dateFormat='dd/mm/yy'
            className={`${informesFilters?.dateFilter && "calendar-selected"}`}
            onChange={({ value }) => {
              setInformesFilters((prevState) => ({
                ...prevState,
                dateFilter: value,
              }))
            }}
            readOnlyInput
            showIcon={!informesFilters?.dateFilter}
          />

          {informesFilters?.dateFilter && (
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='!tw-absolute tw-top-2 tw-right-6 tw-text-simple-10 tw-h-4 tw-w-4 tw-cursor-pointer !tw-pt-1'
              onClick={() => {
                setInformesFilters({
                  ...informesFilters,
                  dateFilter: undefined,
                })
              }}
            />
          )}
        </div>
        <SearchInput
          placeholder={t("informes.saldos.placeholderSearch")}
          onChange={(ev: string) => {
            setInformesFilters({
              ...informesFilters,
              searchValue: ev,
            })
          }}
          inputValue={informesFilters?.searchValue}
          className='tw-mb-1 sm:tw-mb-0 sm:tw-mr-2 tw-h-10 tw-w-full sm:tw-w-72'
        />
        <Icon
          bordered
          onClick={handleDownload}
        >
          {isLoadingExcel ? (
            <ProgressSpinner
              strokeWidth='5'
              className='tw-w-5 tw-h-5 !tw-mt-0'
            />
          ) : (
            <FontAwesomeIcon
              icon={["fal", "arrow-down-to-bracket"]}
              className='download-icon'
            />
          )}
        </Icon>
      </div>
    </HeaderWrapper>
  )
}

export default SubMenuHeader
